module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.e68987a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/font/AmwayIcons.eot?5v2gxx
// module id = efcI
// module chunks = 0